export const getYoutubeVideo = (url) => {
	return `//www.youtube.com/embed/${getYoutubeId(url)}?showinfo=0&rel=0&autoplay=1`;
};
let getYoutubeId = (url) => {
	let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	let match = url.match(regExp);

	if (match && match[2].length == 11) {
		return match[2];
	} else {
		return "";
	}
};

export const getDreambrokerVideo = (url) => {
	let regExp = "dreambroker.com/channel/(.*)";
	let match = url.match(regExp);
	if (match == undefined) return false;
	if (match[1] == undefined) return false;
	let test = match[1].replace(/\/$/, "");
	let id = test.replace(/([\/,!?_])/g, "/iframe/");
	return `https://www.dreambroker.com/channel/${id}?autoplay=1`;
};
